import { platformApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteNotice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => {
      if (code) {
        return platformApi.delete(`notices/${code}`).json();
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notices'] }),
  });
}
